<template>
  <!-- Search Filter -->
  <div class="row filter-row">
    <div class="col-sm-6 col-md-3">
      <v-autocomplete v-model="selectedEmployee" :items="employeeOptions" variant="outlined" density="comfortable"
        item-title="text" item-value="id" clearable label="Employee Name" @update:model-value="onSearchClick"></v-autocomplete>
    </div>

    <div class="col-sm-6 col-md-3">
      <v-autocomplete v-model="company_role_id" :items="companyRole" variant="outlined" density="comfortable"
        item-title="text" item-value="text" clearable label="Role" @update:model-value="onSearchClick"></v-autocomplete>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus select-focus">
        <vue-select :options="Months" v-model="month" id="month" placeholder="-" @update:model-value="onSearchClick" />
        <label class="focus-label">Select Month</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus select-focus">
        <vue-select :options="Year" v-model="year" id="year" placeholder="-" @update:model-value="onSearchClick" />
        <label class="focus-label">Select Year</label>
      </div>
    </div>
    <!-- <div class="col-sm-6 col-md-2">
      <div class="d-flex justify-content-between"> <a href="javascript:;" class="btn btn-success w-100 me-2"
          @click="onSearchClick"> Search </a>
        <a href="javascript:;" class="btn btn-secondary w-100" @click="onClearClick"> clear </a>
      </div>
    </div> -->
  </div>
  <!-- Search Filter -->
</template>

<script>
import { ref } from "vue";
import { VUE_APP_API_BASE_URL } from "../config";
import axios from "axios";

const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
export default {
  props: {
    initialEmployeeId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      select2: null,
      companyRole: [],
      company_role_id: null,
      startdate: currentDate,
      dateFormat: 'dd-MM-yyyy',
      startdateone: currentDateOne,
      selectedEmployee: null,
      employeeOptions: [],
      Months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December ",
      ],
      Year: this.getYears(),
      month: (new Date()).toLocaleString('default', { month: 'long' }),
      year: String((new Date()).getFullYear()),
    };
  },
  mounted() {
    this.getCompanyRoles();
    this.getEmployees();
  },
  methods: {
    onClearClick() {
      this.selectedEmployee = null;
      this.company_role_id = null;
      this.month = (new Date()).toLocaleString('default', { month: 'long' });
      this.year = String((new Date()).getFullYear());
      this.$emit("attFilterClicked", {
        employee_id: null,
        employee_name: null,
        company_role_id: null,
        month: (new Date()).toLocaleString('default', { month: 'long' }),
        year: (new Date()).getFullYear(),
        isSync: false
      });
    },

    async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyRole = response.data.data.map(element => ({
              id: element.id,
              text: element.name
            }));
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async getEmployees() {
      await axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.employeeOptions = response.data.data.map(element => ({
              id: element.id,
              text: `${element.first_name} ${element.last_name}`
            }));
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    onSearchClick() {
      const selectedEmp = this.employeeOptions.find(e => e.id == this.selectedEmployee);
      this.$emit("attFilterClicked", {
        month: (new Date(`${this.month} 1, ${this.year}`)).getMonth() + 1,
        year: this.year,
        employee_id: this.selectedEmployee || null,
        employee_name: selectedEmp ? selectedEmp.text : null,
        company_role_id: this.company_role_id,
        isSync: false
      });
    },
    getYears() {
      let years = [];
      let currentYear = (new Date()).getFullYear();
      for (let i = 0; i < 5; i++) {
        years.push(String(currentYear));
        currentYear -= 1;
      }
      return years;
    },
    syncFilter() {
      if (this.selectedEmployee && this.employeeOptions.length > 0) {
        const selectedEmp = this.employeeOptions.find(e => e.id == this.selectedEmployee);
        if (selectedEmp) {
          const monthNum = typeof this.month === 'string' 
            ? (new Date(`${this.month} 1, ${this.year}`)).getMonth() + 1 
            : this.month;
            
          this.$emit("attFilterClicked", {
            month: monthNum,
            year: this.year,
            employee_id: this.selectedEmployee,
            employee_name: selectedEmp.text,
            company_role_id: this.company_role_id,
            isSync: true
          });
        }
      } else if (this.selectedEmployee === null) {
        this.$emit("attFilterClicked", {
          month: typeof this.month === 'string' ? (new Date(`${this.month} 1, ${this.year}`)).getMonth() + 1 : this.month,
          year: this.year,
          employee_id: null,
          employee_name: null,
          company_role_id: this.company_role_id,
          isSync: true
        });
      }
    }
  },
  watch: {
    initialEmployeeId: {
      handler(val) {
        if (val) {
          this.selectedEmployee = val;
        }
      },
      immediate: true
    },
    selectedEmployee: {
      handler() {
        this.syncFilter();
      }
    },
    employeeOptions: {
      handler() {
        this.syncFilter();
      },
      deep: true
    }
  }
};
</script>
